<template>
  <div class="l-button-main">
    <button
      class="l-btn-default"
      :class="[activeType == type ? 'active': '', `l-btn-type-${type}`, status == 0 ? 'disabled' : '' ]"
      @click="onSelect(type)"
    >
      <span class="l-btn-text">{{ text }}</span>
    </button>
  </div>
</template>

<script>
export default {
  name: 'l-button-common',
  props: {
    type: {
      // 按钮类型
      type: Number, // 1：左  2：右  3：圆短黄（go on）  4：方短绿（提交） 5：方短黄（Next） 6：方短灰（Back）
    },
    text: {
      // 按钮文案
      type: String,
    },
    status: {
      // 按钮状态
      type: Number, // 0: 禁用  1: 默认
    },
  },
  data() {
    return {
      timer: null, // 定时器
      activeType: 0,
    }
  },
  methods: {
    onSelect(type) {
      this.activeType = type
      this.timer = setTimeout(() => {
        this.$emit('select', type)
        this.activeType = 0
      }, 200)
    },
  },
}
</script>

<style lang="stylus" scoped>
@import './index.styl'
@import '../../style/l-btn.styl'
</style>